module.exports = __webpack_public_path__ + "media/shield_dc6b41.png";